/* Kaching Bundles preselects the multi-item deal on load, so the shopper lands
   on an option that cannot be added until they fill in its Kit Choice selects.
   This reselects the plain single-product deal instead.

   This is a theme-side override of an app default. If the preselected deal is
   ever changed inside the Kaching Bundles admin, turn off "Default the bundle
   block to the single product" on the product section and delete this. */
(() => {
  if (window.kachingDefaultDealInitialised) return;
  window.kachingDefaultDealInitialised = true;

  const BLOCK = '.kaching-bundles__block';
  const LOADED = 'kaching-bundles__block--loaded';
  const BAR = '.kaching-bundles__bar';
  const DEAL_RADIO = 'input[type="radio"][name^="kaching-bundles-deal"]';
  const GIVE_UP_AFTER = 15000;

  // Returns true once this block needs no further attention, so the observer
  // below can stop watching the document.
  const select = (block) => {
    if (block.dataset.defaultDealApplied === 'true') return true;

    const bars = Array.from(block.querySelectorAll(BAR));
    if (!bars.length) return false;

    // A block offering one deal has nothing to reselect.
    if (bars.length < 2) {
      block.dataset.defaultDealApplied = 'true';
      return true;
    }

    // The single-product deal is the one with no nested product pickers.
    // Falling back to the first bar matches how the app orders them.
    const plain = bars.find((bar) => !bar.querySelector('select')) || bars[0];
    const radio = plain.querySelector(DEAL_RADIO);
    if (!radio) return false;

    block.dataset.defaultDealApplied = 'true';
    if (radio.checked) return true;

    // The widget keeps its own state, so drive it the way a tap would rather
    // than just flipping the checked property.
    radio.checked = true;
    radio.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    radio.dispatchEvent(new Event('input', { bubbles: true }));
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  };

  const sweep = () => {
    if (!document.documentElement) return true;
    let handledAll = true;
    document.querySelectorAll(BLOCK).forEach((block) => {
      if (!block.classList.contains(LOADED)) {
        handledAll = false;
        return;
      }
      if (!select(block)) handledAll = false;
    });
    return handledAll && document.querySelector(BLOCK) !== null;
  };

  if (sweep()) return;

  // The block is injected and hydrated well after DOMContentLoaded.
  const observer = new MutationObserver(() => {
    if (sweep()) observer.disconnect();
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });
  window.setTimeout(() => observer.disconnect(), GIVE_UP_AFTER);
})();
